import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import React, {
    useCallback,
    useState,
} from 'react';
import { useIntl } from 'react-intl';

import PinDashboardsMenu from './PinDashboardsMenu';

const PinDashboardsButton: React.FC = () => {
    const { formatMessage: translate } = useIntl();
    const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);

    const handleOpen = useCallback((e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget);
    }, []);

    const handleClose = useCallback(() => setAnchorEl(null), []);

    return (
        <>
            <IconButton
                size="small"
                onClick={handleOpen}
                aria-label={translate({ id: 'CLIENT_GOVERNANCE_V2_NAV_PIN_DASHBOARDS' })}
                data-cy="governance-v2-nav-pin-dashboards"
            >
                <AddIcon fontSize="small" />
            </IconButton>
            <PinDashboardsMenu
                anchorEl={anchorEl}
                onClose={handleClose}
                source="Nav" />
        </>
    );
};

export default PinDashboardsButton;
